import { F_Fammily, Font } from "../../../../util/config-fonts";
import { Colors } from "../../../../util/colors";
import ReactDatePicker from "react-datepicker";
import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import { CSP } from "../../../../config/config";
import { parseISO } from "date-fns";

export default class DrawerShecule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      SelectedDate: new Date(),
      filteredDates: [],
      FileterDateslength: 0,
    };
  }

  componentDidMount() {
    const moddate = new Date();
    const datesTime = this.props.dates.filter(
      (date) => date.Datee === moddate.toDateString()
    );

    this.setState({
      DisplayConfirmButton: "none",
      fillterData: moddate.toDateString(),
      filteredDates: datesTime,
      FileterDateslength: datesTime.length,
      SelectedDate: new Date(),
    });
  }

  addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + (parseInt(days) - 1));
    return result;
  }

  toValidDate(date) {
    if (!date) return null;
    return typeof date === "string" ? parseISO(date) : date;
  }

  RenderDateTime() {
    return this.state.filteredDates.map((dates, i) => {
      return (
        <div
          key={i + "dateTimeSlots"}
          onClick={() => {
            this.props.SelectedShedule(dates.Datee, dates.Timee);
          }}
        >
          <div
            style={{
              margin: 5,
              backgroundColor: Colors.DarkGreyScale,
              padding: "8px",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            <div
              style={{
                alignItems: "center",
                margin: 0,
                fontFamily: F_Fammily.Medium,
              }}
            >
              <p
                style={{
                  width: "100%",
                  fontSize: Font.SmallDescription,
                  marginTop: "3px",
                  marginBottom: "3px",
                  color: Colors.FontColor,
                }}
              >
                {dates.Datee}
              </p>
              <p
                style={{
                  width: "100%",
                  fontSize: Font.SmallDescription,
                  marginTop: "3px",
                  marginBottom: "3px",
                  color: Colors.FontColor,
                }}
              >
                {dates.Timee}
              </p>
            </div>
          </div>
        </div>
      );
    });
  }

  render() {
    const minDate = parseISO(this.props.MinimumDate);
    const maxDate = this.addDays(this.props.MinimumDate, this.props.NoOfDaystoshow);

    return (
      <div>
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            display: CSP !== "AV" ? "flex" : "block",
          }}
        >
          <ReactDatePicker
            minDate={minDate}
            maxDate={maxDate}
            inline
            selected={this.toValidDate(this.state.SelectedDate)}
            onChange={(date) => {
              const moddate = new Date(date);
              const datesTime = this.props.dates.filter(
                (date) => date.Datee === moddate.toDateString()
              );

              this.setState({
                DisplayConfirmButton: "none",
                fillterData: moddate.toDateString(),
                filteredDates: datesTime,
                FileterDateslength: datesTime.length,
                SelectedDate: date,
              });
            }}
          />
        </div>

        {this.state.FileterDateslength > 0 ? (
          this.RenderDateTime()
        ) : (
          <div
            style={{
              justifyContent: "center",
              alignItems: "center",
              alignContent: "center",
              marginTop: 100,
              borderWidth: 1,
              padding: 10,
              borderColor: "#b71540",
            }}
          >
            <p
              style={{
                textAlign: "center",
                fontSize: 20,
                fontWeight: "bold",
                color: "#b71540",
              }}
            >
              Sorry Time Slots not available for the selected date
            </p>
          </div>
        )}
      </div>
    );
  }
}
